import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DefaultInput from '../DefaultInput';
import PinCodeInputStyled from './styles/PinCodeInputStyled';
import Message from '../InputMessage';

class PinCodeInput extends PureComponent {
  constructor(props) {
    super(props);
    this.value = '';
  }

  onChange = ({ value }) => {
    this.value = value;
    this.props.onValueChange(value);
  };

  onFocusChange = ({ focused }) => {
    this.props.onFocusChange(focused);
  };

  render() {
    const { errorMessage } = this.props;
    return (
      <PinCodeInputStyled>
        <DefaultInput
          {...this.props}
          type="tel"
          size={4}
          filter
          isError={Boolean(errorMessage)}
          onChange={this.onChange}
          onFocusChange={this.onFocusChange}
          align="center"
          textType="rarefied"
          placeholder="••••"
        />
        <Message message={errorMessage} />
      </PinCodeInputStyled>
    );
  }
}

PinCodeInput.propTypes = {
  onValueChange: PropTypes.func,
  errorMessage: PropTypes.string,
  onFocusChange: PropTypes.func,
};

PinCodeInput.defaultProps = {
  onValueChange: Function.prototype,
  onFocusChange: Function.prototype,
  errorMessage: '',
};

export default PinCodeInput;
